<template lang="pug">
#ReingresarEvaluacion
  b-button(
    variant="action"
    @click="showModal = true"
    :disabled="loading"
  )
    b-spinner(v-if="loading" small)
    span {{ loading ? ' Procesando...' : ' Reingresar a evaluación' }}

  b-modal(
    v-model="showModal"
    centered
    header-border-variant="white"
    footer-border-variant="white"
    content-class="reingresar-modal"
    no-close-on-backdrop
    @hidden="showModal = false"
  )
    template(#modal-header="{ close }")
      h5.reingresar-modal__title Reingresar OT a evaluación
      b-icon-x.cursor-pointer.h4.mb-0.text-muted(@click="close" v-if="!loading")

    .text-center.reingresar-modal__body
      .reingresar-modal__icon-wrap.mb-4
        b-icon-exclamation-triangle-fill.reingresar-modal__icon

      p.reingresar-modal__text
        | Estás a punto de devolver esta Orden de Trabajo&nbsp;
        strong [ID OT {{ dataOv.ot }}]&nbsp;
        | a la etapa de evaluación inicial.
      p.reingresar-modal__text
        strong Importante:&nbsp;
        | Esta acción eliminará permanentemente el diagnóstico actual y marcará la cotización asociada como rechazada y cerrada.
      p.reingresar-modal__note Esta es una acción interna y el cliente no será notificado.
      b-spinner(v-if="loading" variant="danger" class="mt-3")

    template(#modal-footer="{ close }")
      .w-100.d-flex.justify-content-between
        b-button.reingresar-modal__btn-cancel(@click="close" :disabled="loading") Cancelar
        b-button.reingresar-modal__btn-confirm(@click="confirmar" :disabled="loading")
          | Sí, reingresar y borrar diagnóstico
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ReingresarEvaluacion',
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('OVStore', ['reingresarEvaluacion']),
    async confirmar(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.loading = true
      try {
        const response = await this.reingresarEvaluacion(this.dataOv.id)
        if (response.status === 200) {
          this.$bvToast.toast(
            'La OT fue devuelta a En Evaluación. El diagnóstico fue eliminado.',
            {
              title: 'Reingreso exitoso',
              variant: 'success',
              solid: true,
            }
          )
          this.showModal = false
          this.$emit('reloadAll')
        }
      } catch (error) {
        this.$bvToast.toast(
          error.response?.data?.error || 'Error al reingresar a evaluación',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
        this.showModal = false
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.reingresar-modal {
  .modal-content {
    border-radius: 12px;
    border: none;
  }
  .modal-header {
    padding: 24px 24px 0 24px;
    border-bottom: none;
  }
  .modal-footer {
    padding: 0 24px 24px 24px;
    border-top: none;
  }
  .modal-body {
    padding: 16px 24px;
  }

  &__title {
    font-weight: 700;
    font-size: 18px;
    color: #23201c;
    margin: 0;
  }

  &__body {
    padding: 8px 8px 0;
  }

  &__icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
  }

  &__icon {
    font-size: 72px;
    color: #ff3c3c;
  }

  &__text {
    color: #23201c;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 12px;
  }

  &__note {
    font-size: 13px;
    color: #525252;
    margin-bottom: 0;
  }

  &__btn-cancel {
    background-color: white !important;
    color: #23201c !important;
    border: 1px solid #fccc3c !important;
    font-weight: 600;
    border-radius: 8px;
    padding: 10px 24px;

    &:hover:not(:disabled) {
      background-color: #fff9e6 !important;
    }
  }

  &__btn-confirm {
    background-color: #fccc3c !important;
    color: #23201c !important;
    border: none !important;
    font-weight: 600;
    border-radius: 8px;
    padding: 10px 20px;

    &:hover:not(:disabled) {
      background-color: #f7be16 !important;
    }
  }
}
</style>
